import React, {
  createContext,
  useContext,
  type ComponentType,
  type PropsWithChildren,
  type ReactNode,
} from 'react';
import cn from 'classnames';

import * as styles from './styles.module.css';

export type TabBarItemProps = {
  icon: ReactNode;
  text: string;
  isActive?: boolean;
  href: string;
  notificationSlot?: ReactNode;
};

type LinkType = ComponentType<PropsWithChildren<{ to: string; className?: string }>>;

const LinkContext = createContext<LinkType | undefined>(undefined);

export function TabBarItem({
  icon,
  text,
  isActive = false,
  href,
  notificationSlot,
}: TabBarItemProps) {
  const LinkComp = useContext(LinkContext);

  const isExternal = href.startsWith('https://');
  const content = (
    <>
      <div className={styles.iconContainer}>
        {icon}
        <div className={styles.slot}>{notificationSlot}</div>
      </div>
      <span>{text}</span>
    </>
  );

  return !isExternal && LinkComp ? (
    <LinkComp to={href} className={cn(styles.item, isActive && styles.active)}>
      {content}
    </LinkComp>
  ) : (
    <a href={href} className={styles.item}>
      {content}
    </a>
  );
}

export function TabBarContainer({ children, LinkComp }: PropsWithChildren<{ LinkComp: LinkType }>) {
  return (
    <div className={styles.tabBarContainer}>
      <LinkContext.Provider value={LinkComp}>{children}</LinkContext.Provider>
    </div>
  );
}
